<template>
    <v-layout wrap>
        <v-flex class="mb-1 d-flex align-items-center">
            <div>
                <h1 class="d-inline-block vertical-align-middle">{{ $t('manage-operating-list') }}</h1>
                <v-tooltip bottom>
                    <v-btn icon flat slot="activator">
                        <v-icon>mdi-help-circle</v-icon>
                    </v-btn>
                    <span>{{ $t('help') }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <v-btn icon flat slot="activator" @click="OpenReport()">
                        <v-icon>mdi-file-chart</v-icon>
                    </v-btn>
                    <span>{{ $t('report') }}</span>
                </v-tooltip>
                <v-flex mb-3 md4 px-2>
                    <v-btn @click="OpenReport2()">
                        {{   $t('Print-Manage-Details') }}
                    </v-btn>
                </v-flex>
            </div>
            <!-- ManageOperatingRequests -->
            <div class="text-xs-right">
                <v-btn v-can:add :to="{ name: 'add-manage-operating' }" color="success">
                    <v-icon left>add</v-icon>
                    {{ $t('add-new-manage-operating') }}
                </v-btn>
                <v-menu v-if="selected.length" bottom left origin="center center" transition="scale-transition" min-width="100">
                    <v-btn icon flat slot="activator">
                        <v-icon>more_vert</v-icon>
                    </v-btn>
                    <v-list>
                        <v-list-tile @click="deleteManageOperatingRequests" v-can:delete>
                            <v-list-tile-title>Delete</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="postManageOperatingRequests" v-can:post>
                            <v-list-tile-title>Post</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="unpostManageOperatingRequests" v-can:unpost>
                            <v-list-tile-title>Unpost</v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </div>
        </v-flex>
        <!-- Search box -->
        <v-flex xs12>
            <v-card class="pa-3 mb-3">
                <v-layout wrap>
                    <!--<v-flex xs12>
        <v-text-field v-model="keyword"
                      append-icon="mdi-magnify"
                      :label="$t('search')"
                      single-line
                      hide-details
                      @change="getManageOperatingRequests"></v-text-field>
    </v-flex>-->
                    <v-flex md2 sm6 xs12 px-2>
                        <v-text-field :label="$t('national-number')" @change="getManageOperatingRequests" v-model="beneficiaryNationalNumJOR"></v-text-field>
                    </v-flex>
                    <v-flex md4 px-2 sm6 xs12>
                        <v-menu :close-on-content-click="false"
                                :nudge-right="40"
                                full-width
                                lazy
                                min-width="290px"
                                offset-y
                                ref="menu"
                                transition="scale-transition"
                                v-model="fromDateMenu">
                            <v-text-field :data-vv-as="$t('from-date')"
                                          :error-messages="errors.collect('fromDate')"
                                          :label="$t('from-date-creation')"
                                          clearable
                                          name="fromDate"
                                          prepend-icon="event"
                                          readonly
                                          slot="activator"
                                          v-model="fromDate"></v-text-field>
                            <v-date-picker :min="'1900-01-01'"
                                           :max="''"
                                           @change="fromDateMenu = false"
                                           ref="picker"
                                           v-model="fromDate"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex md4 px-2 sm6 xs12>
                        <v-menu :close-on-content-click="false"
                                :nudge-right="40"
                                full-width
                                lazy
                                min-width="290px"
                                offset-y
                                ref="menu"
                                transition="scale-transition"
                                v-model="toDateMenu">
                            <v-text-field :data-vv-as="$t('to-date')"
                                          :error-messages="errors.collect('toDate')"
                                          :label="$t('to-date-creation')"
                                          clearable
                                          name="toDate"
                                          prepend-icon="event"
                                          readonly
                                          slot="activator"
                                          v-model="toDate"></v-text-field>
                            <v-date-picker :min="'1900-01-01'"
                                           @change="toDateMenu = false"
                                           ref="picker"
                                           v-model="toDate"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex md3 px-2 sm6 xs12>
                        <v-autocomplete :data-vv-as="$t('governorate')"
                                        :item-text="getLabelByLang('name', 'name')"
                                        :items="governoratesList"
                                        :label="$t('governorate')"
                                        clearable
                                        item-value="code"
                                        name="governorate"
                                        v-model="governorate"></v-autocomplete>
                    </v-flex>
                    <v-flex md3 px-2 sm6 xs12>
                        <v-autocomplete :data-vv-as="$t('city')"
                                        :item-text="getLabelByLang('name', 'name')"
                                        :items="citiesList"
                                        :label="$t('city')"
                                        clearable
                                        item-value="code"
                                        name="city"
                                        v-model="city"></v-autocomplete>
                    </v-flex>
                    <v-flex md4 px-2 sm6 xs12>
                        <v-autocomplete :data-vv-as="$t('transaction')"
                                        :item-text="getLabelByLang('name', 'name')"
                                        :items="transactionList"
                                        :label="$t('transaction')"
                                        clearable
                                        item-value="code"
                                        name="procedureType"
                                        v-model="procedureType"></v-autocomplete>
                    </v-flex>
                    <v-flex md3 px-2 sm6 xs12>
                        <v-autocomplete :data-vv-as="$t('disability-type')"
                                        :item-text="getLabelByLang('name', 'name')"
                                        :items="disabilityNaturesList"
                                        :label="$t('disability-type')"
                                        clearable
                                        item-value="code"
                                        name="typeOfDisability"
                                        v-model="disabilityType"></v-autocomplete>
                    </v-flex>

                    <v-flex md4 px-2 sm6 xs12>
                        <v-text-field :label="$t('full-name')" name="fullName" v-model="fullName"></v-text-field>
                    </v-flex>

                    <v-flex xs12>
                        <v-btn color="primary" type="submit" @click="getManageOperatingRequests()">{{ $t('filter') }}</v-btn>
                        <v-btn color="primary" type="reset" @click="filterInit()">{{ $t('reset') }}</v-btn>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
        <!-- Data Table -->
        <v-flex xs12>
            <v-data-table :rows-per-page-items="[10, 25, { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }]"
                          :loading="isLoading"
                          :headers="headers"
                          :items="manageOperatingRequests"
                          v-model="selected"
                          select-all
                          class="elevation-1">
                <template slot="items" slot-scope="props">
                    <tr :key="props.index" :class="props.item.isActive ? '' : 'is-posted'">
                        <td>
                            <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
                        </td>
                        <td>{{ props.item.createdat | date }}</td>
                        <td>{{ props.item.fullName }}</td>
                        <td>{{ props.item.nationalityID }}</td>
                        <td>{{ props.item.education }}</td>
                        <td>{{ props.item.specilaity }}</td>
                        <td>
                            <v-btn icon
                                   v-can:edit
                                   :to="{
                  name: 'edit-manage-operating',
                  params: { beneficiaryInformationId: props.item.beneficiaryInfoId, id: props.item.id }
                }">
                                <v-icon>edit</v-icon>
                            </v-btn>
                        </td>
                        <!--<td>
                            <v-icon v-show="props.item.isActive">mdi-account-check mdi-36px</v-icon>
                            <v-icon v-show="!props.item.isActive">mdi-check-outline</v-icon>
                        </td>-->
                    </tr>
                </template>
            </v-data-table>
            <v-btn color="primary" type="reset" @click="deleteManageOperatingRequests()">{{ $t('delete') }}</v-btn>
        </v-flex>
    </v-layout>
</template>

<script>
    import { ConfirmationEvent } from '@/components/Confirmation/ConfirmationEventBus';
    import ManageOperatingRequestsService from '@/services/Disabilities/PersonWithDisabilities/ManageOperatingRequests/ManageOperatingRequestsService';
    import LookUpService from '@/services/LookUpService';
    import SettingOrgService from "@/services/AdminSystem/OrganizationStructure/SettingOrgService";

    export default {
        name: 'manage-operating',
        data() {
            return {
                manageOperatingRequests: [],
                selected: [],
                keyword: '',
                beneficiaryNationalNumJOR: '',
                isLoading: false,
                transactionList: [],
                citiesList: [],
                governoratesList: [],
                disabilityNaturesList: [],
                fromDate: null,
                toDate: null,
                governorate: '',
                city: '',
                fromDateMenu: false,
                toDateMenu: false,
                procedureType: '',
                disabilityType: '',
                fullName: '', 
            };
        },
        async created() {
            await this.getManageOperatingRequests();
            await this.getGovernorates();
            await this.getCities();
            await this.getTransactionList();
            await this.getDisabilityNatures();
        },
        methods: {
            async getDisabilityNatures() {
                this.disabilityNaturesList = (await LookUpService.getLookup(112)).data;
            },
            async getTransactionList() {
                this.transactionList = (await LookUpService.getLookup(341)).data;
            },
            async getGovernorates() {
                this.governoratesList = (await LookUpService.getLookup(62)).data;
            },
            async getCities() {
                this.citiesList = (await LookUpService.getLookup(100)).data;
            },
            async getManageOperatingRequests() {
                this.manageOperatingRequests = [];
                this.isLoading = true;
                const manageOperatingRequests = (await ManageOperatingRequestsService.getManageOperatingRequestsByCriteria({
                    keyword: this.keyword,
                    beneficiaryNationalNumJOR: this.beneficiaryNationalNumJOR,
                    fromDate: this.fromDate,
                    toDate: this.toDate,
                    governorate: this.governorate,
                    procedureType: this.procedureType,
                    city: this.city,
                    disabilityType: this.disabilityType,
                    fullName:this.fullName,
                }))
                    .data;
                this.manageOperatingRequests = manageOperatingRequests;
                this.isLoading = false;
            },
            async  filterInit() {
                this.keyword = '';
                this.beneficiaryNationalNumJOR = '';
                this.fromDate = null;
                this.toDate = null;
                this.governorate = '';
                this.city = '';
                this.procedureType = '';
                this.disabilityType = '';
                this.fullName = '';
                this.getManageOperatingRequests();
            },
            deleteManageOperatingRequests() {
                this.$store.dispatch('confirm');
                ConfirmationEvent.$on('onSuccess', async () => {
                    /* Show loading on delete users */
                    this.$store.dispatch('showLoading');
                    const result = await ManageOperatingRequestsService.deleteManageOperatingRequests(this.selectedIds);
                    this.selected = [];
                    this.$store.dispatch('hideLoading');
                    if (result.data.statusCode === 200) {
                        //var firstIndexOf = result.data.message.indexOf('(') + 1;
                        //var lastIndexOf = result.data.message.indexOf(')');
                        //var gropsNames = result.data.message.substring(firstIndexOf, lastIndexOf);
                        //var arrayNames = gropsNames.split(',');
                        //var displayString = `${this.$t('delete')} ${arrayNames.length} ${this.$t('manage-operating-requests')}`;
                        //arrayNames.forEach((manageOperatingRequests, index) => {
                        //    displayString += `\n ${index + 1} - ${manageOperatingRequests}`;
                        //});
                        this.$store.dispatch('showMessage', {
                            text: result.data.message,
                            multiLine: true
                        });
                    } else {
                        this.$store.dispatch('showMessage', {
                            text: result.data.message,
                            color: 'error'
                        });
                    }
                    await this.getManageOperatingRequests();
                });
            },
            async postManageOperatingRequests() {
                let postManageOperatingRequests = [];
                for (let i = 0; i < this.selected.length; i++) {
                    postManageOperatingRequests.push({ id: this.selectedIds[i].id, isActive: true });
                }
                const result = await ManageOperatingRequestsService.postManageOperatingRequests(postManageOperatingRequests);
                this.selected = [];
                if (result.data.statusCode === 200) {
                    const firstIndexOf = result.data.message.indexOf('(') + 1;
                    const lastIndexOf = result.data.message.indexOf(')');
                    const message = result.data.message.substring(0, firstIndexOf - 1);
                    const namesList = result.data.message.substring(firstIndexOf, lastIndexOf).split(',');
                    let namesAfterLoop = '<ol>';
                    namesList.forEach(item => {
                        namesAfterLoop += `<li>${item}</li>`;
                    });
                    namesAfterLoop += '</ol>';
                    this.$store.dispatch('showMessage', {
                        text: message + '</br>' + namesAfterLoop,
                        multiLine: true
                    });
                } else {
                    this.$store.dispatch('showMessage', {
                        text: result.data.message,
                        color: 'error'
                    });
                }
                await this.getManageOperatingRequests();
            },
            async unpostManageOperatingRequests() {
                let postManageOperatingRequests = [];
                for (let i = 0; i < this.selected.length; i++) {
                    postManageOperatingRequests.push({ id: this.selectedIds[i].id, isActive: false });
                }
                const result = await ManageOperatingRequestsService.postManageOperatingRequests(postManageOperatingRequests);
                this.selected = [];
                if (result.data.statusCode === 200) {
                    const firstIndexOf = result.data.message.indexOf('(') + 1;
                    const lastIndexOf = result.data.message.indexOf(')');
                    const message = result.data.message.substring(0, firstIndexOf - 1);
                    const namesList = result.data.message.substring(firstIndexOf, lastIndexOf).split(',');
                    let namesAfterLoop = '<ol>';
                    namesList.forEach(item => {
                        namesAfterLoop += `<li>${item}</li>`;
                    });
                    namesAfterLoop += '</ol>';
                    this.$store.dispatch('showMessage', {
                        text: message + '</br>' + namesAfterLoop,
                        multiLine: true
                    });
                } else {
                    this.$store.dispatch('showMessage', {
                        text: result.data.message,
                        color: 'error'
                    });
                }
                await this.getManageOperatingRequests();
            },
            async   OpenReport() {
                const settingOrg = (await SettingOrgService.GetSettingOrganizationByCriteria({ keyword: "" })).data;
                if (settingOrg) {
                    window.open(settingOrg[0].reportURL + 'HCDreport/Pages/Manage.aspx?disabilityType=' + this.disabilityType, '_blank');
                }
            },
            async OpenReport2() {
                const settingOrg = (await SettingOrgService.GetSettingOrganizationByCriteria({ keyword: "" })).data;
                if (this.fromDate === null) {
                   this.fromDate="1/1/2020";
                }
                 if (this.toDate === null) {
                   this.toDate="1/1/2050";
                }
                if (settingOrg) {
                    window.open(settingOrg[0].reportURL + 'HCDreport/Pages/ManageDetails.aspx?fromdate=' + this.fromDate + '&toDate=' + this.toDate, '_blank');
                }
            },
        },
        computed: {
            selectedIds() {
                return this.selected.map(manageOperatingRequests => ({
                    id: manageOperatingRequests.id
                }));
            },

            headers() {
                return [
                    { text: this.$t('request-date'), value: 'createdat', sortable: false },
                    {
                        text: this.$t('national-Num'),
                        value: 'nationalityID',
                        sortable: false
                    },
                    {
                        text: this.$t('full-Name'),
                        value: 'fullName',
                        sortable: false
                    },
                    {
                        text: this.$t('educational-level'),
                        value: 'education',
                        sortable: false
                    },
                    {
                        text: this.$t('specialization'),
                        value: 'specilaity',
                        sortable: false
                    },
                    { text: this.$t('edit'), value: '', sortable: false },
                    //{ text: this.$t('PostStatus'), value: 'isActive', sortable: false }
                ];
            }
        }
    };
</script>  